export const completMonth = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro",
];

const simpleMonth = [
  "Jan",
  "Fev",
  "Mar",
  "Abr",
  "Mai",
  "Jun",
  "Jul",
  "Ago",
  "Set",
  "Out",
  "Nov",
  "Dez",
];

export const formatDateIgnoringTimezone = (dateString: string): string => {
  if (!dateString) return "Data inválida";

  try {
    // Extrai apenas a parte da data (ignorando o timezone)
    const [datePart] = dateString.split("T");
    const [year, month, day] = datePart.split("-").map(Number);

    // Valida se os valores são números válidos
    if (isNaN(year) || isNaN(month) || isNaN(day)) {
      throw new Error("Formato de data inválido");
    }

    // Formata a data ignorando completamente o timezone
    return `${day.toString().padStart(2, "0")}/${month.toString().padStart(2, "0")}/${year}`;
  } catch {
    return "Data inválida";
  }
};

export const dateFormat = (date: string) => {
  const infos = date.split("-");
  const year = infos[0];
  const monthIndex = parseInt(infos[1], 10) - 1;
  const day = infos[2];
  const dataFormatada = day + " " + simpleMonth[monthIndex] + " " + year;

  return dataFormatada;
};

export const dateReferenceFormat = (date: string) => {
  const infos = date.split("-");
  const year = infos[0];
  const monthIndex = parseInt(infos[1], 10) - 1;
  const dataFormatada = simpleMonth[monthIndex] + " " + year;

  return dataFormatada;
};

export const monthFormat = (date: string) => {
  const infos = date.split("-");
  const monthIndex = parseInt(infos[1], 10) - 1;
  const dataFormatada = completMonth[monthIndex];

  return dataFormatada;
};

export const monthYearFormat = (date: string) => {
  const infos = date.split("-");
  const year = infos[0];
  const monthIndex = parseInt(infos[1], 10) - 1;
  const dataFormatada = completMonth[monthIndex] + " " + "de" + " " + year;

  return dataFormatada;
};

export const simpleMonthYearFormat = (date: string) => {
  const infos = date.split("-");
  const year = infos[0];
  const monthIndex = parseInt(infos[1], 10) - 1;
  const dataFormatada = simpleMonth[monthIndex] + " " + year;

  return dataFormatada;
};

export const monthSlashYearFormat = (date: string) => {
  const infos = date.split("-");
  const year = infos[0].slice(-2);
  const monthIndex = parseInt(infos[1], 10) - 1;
  return completMonth[monthIndex] + "/" + year;
};

export const getMonth = () => {
  const objDate = new Date();
  const locale = "pt-br",
    month = objDate.toLocaleString(locale, { month: "long" });

  return month;
};

export const getFullDate = (date: Date) => {
  return `${date.getDate() > 9 ? date.getDate() : "0" + date.getDate()}/${getMonthYearDate(date)}`;
};

export const getMonthYearDate = (date: Date) => {
  return `${
    date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
  }/${date.getFullYear()}`;
};
